/**
 * Combine Reducers Redux Data
 */
import { combineReducers } from 'redux';

export  const rootReducer = combineReducers({ });